module.exports = __webpack_public_path__ + "img/icon-video-meeting-white.4e576cef.svg";